module.exports = __webpack_public_path__ + "static/media/logo_lazarus.d2dcc3bf.png";